import { useEffect, useState } from 'react';
import { getStoredUser, isAuthenticated as checkAuth, type StoredUser } from '@/shared/lib/auth';

const AUTH_EVENT = 'jc:auth-changed';

export const notifyAuthChanged = (): void => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(AUTH_EVENT));
};

type AuthState = {
  user: StoredUser | null;
  isAuthenticated: boolean;
};

const readState = (): AuthState => ({
  user: getStoredUser(),
  isAuthenticated: checkAuth(),
});

export const useAuthState = (): AuthState => {
  const [state, setState] = useState<AuthState>(readState);

  useEffect(() => {
    const handler = (): void => setState(readState());
    window.addEventListener(AUTH_EVENT, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(AUTH_EVENT, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  return state;
};
